import React from 'react';
import { Link } from 'react-router-dom';
import Pricing from '../../components/Pricing/Pricing';
import './PricingPage.scss';

interface PricingPageProps {
  menuOpen: boolean;
}

const PricingPage: React.FC<PricingPageProps> = ({ menuOpen }) => {
  return (
    <div className={`pricing-page ${menuOpen ? 'menu-open' : ''}`}>
      <div className="pricing-page__background"></div>
      <div className="pricing-page__hero">
        <div className="pricing-page__content">
          <h1 className="pricing-page__title">PRICING & PACKAGES</h1>
          
          <div className="pricing-page__text-content">
            <div className="pricing-page__intro">
              <p>
                We offer flexible packages designed to capture your wedding day beautifully. Every package includes 
                professional filming, expert editing, colour grading, and delivery of your final film in high definition.
              </p>
            </div>

            <div className="pricing-page__packages">
              <Pricing />
            </div>

            <div className="pricing-page__custom">
              <h2>Custom Packages</h2>
              <p>
                Every wedding is unique. If our standard packages don't quite fit your needs, we're happy to create 
                a bespoke package tailored to your day. Get in touch to discuss your requirements.
              </p>
              <Link to="/contact" className="pricing-page__cta-btn">Contact Us</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingPage;
